// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
import colors from '../../common/theme/colors';
import constants from '../../common/theme/constants';

import { ThemeSchema } from '../../index';

const KitDropDownMenu = styled.ul<{ bg?: string; theme?: ThemeSchema }>`
  && {
    font-family: ${({ theme }) => theme.font.fontFamily};
    display: flex;
    flex-direction: column;
    inset: auto;
    margin: 0;
    background-color: ${({ theme, bg }) => bg ?? theme.page.header.bg};
    z-index: ${constants.zIndex.dropDown};
    border-radius: 0;
    border: none;
    box-shadow: 0 2px 4px 0 ${colors.gray_40}77;
    padding: 0;
  }
`;

export default KitDropDownMenu;
